export default __webpack_public_path__ + "static/media/ru.7e04b988.svg";